import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { FolioDataExtractSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportFolioDataExtract, sortFolioDataExtract } from '../../constants';
import { searchFolioDataExtract, searchAllFolioDataExtract, pushKPIExtract } from '../../actions';
import { makeGetListFolioDataExtract, makeGetListAllFolioDataExtract } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class FolioDataExtract extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      folioDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listFolioDataExtract: [],
    filterInput: {
      folioDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
    },
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listFolioDataExtract: props.listFolioDataExtract,
      totalCount: getPageTotalCount({ ...state, items: props.listFolioDataExtract }),
    };
  }

  componentDidMount() {
    this.doGetListFolioDataExtract();
    const {
      permissions: { modeGetSearchKPIExtract },
    } = this.props;
    if (modeGetSearchKPIExtract) {
      this.doGetListFolioDataExtract();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListFolioDataExtract();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListFolioDataExtract());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListFolioDataExtract());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListFolioDataExtract();
    });
  };

  doGetListFolioDataExtract = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchFolioDataExtract } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortFolioDataExtract[sorted.sortCol]
          ? sortFolioDataExtract[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    searchFolioDataExtract(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistFolioDataExtract = cb => {
    const { filter, sorted } = this.state;
    const { searchAllFolioDataExtract } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortFolioDataExtract[sorted.sortCol][sorted.sortDir] : null,
    };
    searchAllFolioDataExtract(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistFolioDataExtract(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllFolioDataExtract, t } = this.props;
        convertJson2Pdf({
          data: listAllFolioDataExtract,
          t,
          title: t('reportPage:sidebar.KPI').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.KPI')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 2,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistFolioDataExtract(() => {
      const { listAllFolioDataExtract, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'SEARCH_KPI_EXTRACT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.KPI')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.KPI')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllFolioDataExtract,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { jobType: 'jobTypes', jobStatus: 'jobStatus' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllFolioDataExtract,
          t,
          title: t('reportPage:sidebar.KPI').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.KPI')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 2,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.KPI')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('KPI_EXTRACTS', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportFolioDataExtract,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  doPushKPIExtract = () => {
    const { pushKPIExtract } = this.props;
    const { filter, sorted, filterInput } = this.state;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: { folioDate: filterInput?.folioDate },
      sort: !isEmpty(sorted) ? sortFolioDataExtract[sorted.sortCol][sorted.sortDir] : null,
    };
    pushKPIExtract(payload, () => {
      this.setState({ filter: filterInput }, () => this.doGetListFolioDataExtract());
    });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listFolioDataExtract,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
      filterInput,
    } = this.state;
    const {
      listAllFolioDataExtract,
      t,
      permissions: { modeGetSearchKPIExtract, modeDownloadReport, modeGetMailReport, modePushKPIExtract },
    } = this.props;
    if (!modeGetSearchKPIExtract) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];

    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[{ name: t('label.report'), url: RouteNames.report.path }, { name: t('reportPage:sidebar.KPI') }]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.KPI')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <FolioDataExtractSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  defaultFilter={filter}
                  handleInputChange={({ name, value }) => {
                    filterInput[name] = value || null;
                    this.setState({ filterInput: { ...filterInput } });
                  }}
                  onHandleClearInput={() => {
                    this.setState({
                      filterInput: {},
                    });
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.KPI').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllFolioDataExtract,
                          t,
                          title: t('reportPage:sidebar.KPI').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.KPI')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listFolioDataExtract}
                    />
                  )}
                </div>
                {!!modePushKPIExtract && (
                  <div className="col-md-12 pt-4 pb-2 pl-3">
                    <button
                      type="button"
                      className="button button-border x-small float-right mb-3"
                      onClick={this.doPushKPIExtract}
                      disabled={
                        modePushKPIExtract === 1 ||
                        !filterInput?.folioDate ||
                        filterInput?.organization ||
                        filterInput?.commercialName ||
                        filterInput?.clientId ||
                        filterInput?.salesAgentId ||
                        filterInput?.productFamily
                      }
                    >
                      {t('label.push')}
                    </button>
                  </div>
                )}
                <DataTable
                  columns={tableColumnsOutput}
                  data={listFolioDataExtract && listFolioDataExtract.length ? listFolioDataExtract : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

FolioDataExtract.propTypes = {
  searchFolioDataExtract: PropTypes.func,
  searchAllFolioDataExtract: PropTypes.func,
  listAllFolioDataExtract: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

FolioDataExtract.defaultProps = {
  searchFolioDataExtract: () => {},
  searchAllFolioDataExtract: () => {},
  listAllFolioDataExtract: [],
};

const mapStateToProps = createStructuredSelector({
  listFolioDataExtract: makeGetListFolioDataExtract() || [],
  listAllFolioDataExtract: makeGetListAllFolioDataExtract() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    searchFolioDataExtract,
    searchAllFolioDataExtract,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    pushKPIExtract,
  })(FolioDataExtract)
);
